<script lang="ts">
    import emailjs from '@emailjs/browser';

    let formData = {
        name: '',
        email: '',
        phone: '',
        message: ''
    };

    let isSubmitting = false;
    let submitStatus: 'idle' | 'success' | 'error' = 'idle';

    const EMAILJS_SERVICE_ID = 'service_zo4dfcb';
    const EMAILJS_TEMPLATE_ID = 'template_lvlhmnm';
    const EMAILJS_PUBLIC_KEY = '_Jl0A-r0ljc7I9g6B';

    async function handleSubmit(event: Event) {
        event.preventDefault();
        isSubmitting = true;
        submitStatus = 'idle';

        try {
            await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_TEMPLATE_ID,
                {
                    from_name: formData.name,
                    from_email: formData.email,
                    from_phone: formData.phone,
                    message: formData.message,
                },
                EMAILJS_PUBLIC_KEY
            );

            submitStatus = 'success';
            formData = { name: '', email: '', phone: '', message: '' };
        } catch (error) {
            console.error('EmailJS error:', error);
            submitStatus = 'error';
        } finally {
            isSubmitting = false;
        }
    }
</script>

<section class="py-20 bg-background">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
            <h2 class="text-3xl md:text-4xl text-primary mb-4">
                Kontakt
            </h2>
            <p class="text-lg text-[#6B5D4F] max-w-3xl mx-auto">
                Ste pripravení urobiť prvý krok? Som tu, aby som vám pomohla. Kontaktujte ma pre dohodnutie konzultácie.
            </p>
        </div>

        <div class="grid md:grid-cols-2 gap-12">
            <div class="space-y-8">
                <!-- Phone -->
                <div class="flex items-start space-x-4">
                    <div class="bg-primary w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-lg text-primary mb-1">Telefón</h3>
                        <p class="text-[#6B5D4F]">+421 910 419 666</p>
                        <p class="text-sm text-[#6B5D4F]">Zavolajte alebo napíšte SMS pre dohodnutie stretnutia</p>
                    </div>
                </div>

                <!-- Email -->
                <div class="flex items-start space-x-4">
                    <div class="bg-primary w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-lg text-primary mb-1">Email</h3>
                        <p class="text-[#6B5D4F]">andrea@andreapsycholog.sk</p>
                    </div>
                </div>

                <!-- Location -->
                <div class="flex items-start space-x-4">
                    <div class="bg-primary w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-lg text-primary mb-1">Adresa</h3>
                        <p class="text-[#6B5D4F]">ViaSua, Hlavná 68</p>
                        <p class="text-[#6B5D4F]">Košice, 040 01</p>
                        <p class="text-sm text-[#6B5D4F] mt-1">Ponúkam aj online konzultácie</p>
                    </div>
                </div>
            </div>

            <!-- Contact Form -->
            <div class="bg-white p-8 rounded-2xl shadow-lg">
                <h3 class="text-2xl text-primary mb-6">Napíšte mi</h3>
                <form on:submit={handleSubmit} class="space-y-4">
                    <div>
                        <label for="name" class="block text-text mb-2">
                            Meno
                        </label>
                        <input
                            type="text"
                            id="name"
                            bind:value={formData.name}
                            required
                            class="w-full px-4 py-3 border border-secondary rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white"
                            placeholder="Vaše meno"
                        />
                    </div>
                    <div>
                        <label for="email" class="block text-text mb-2">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            bind:value={formData.email}
                            required
                            class="w-full px-4 py-3 border border-secondary rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white"
                            placeholder="vas@email.com"
                        />
                    </div>
                    <div>
                        <label for="phone" class="block text-text mb-2">
                            Telefón (voliteľné)
                        </label>
                        <input
                            type="tel"
                            id="phone"
                            bind:value={formData.phone}
                            class="w-full px-4 py-3 border border-secondary rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white"
                            placeholder="+421 9XX XXX XXX"
                        />
                    </div>
                    <div>
                        <label for="message" class="block text-text mb-2">
                            Správa
                        </label>
                        <textarea
                            id="message"
                            bind:value={formData.message}
                            rows="4"
                            required
                            class="w-full px-4 py-3 border border-secondary rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white resize-none"
                            placeholder="Ako vám môžem pomôcť?"
                        ></textarea>
                    </div>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        class="w-full bg-primary text-white py-3 rounded-lg hover:bg-primary-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isSubmitting ? 'Odosielam...' : 'Odoslať správu'}
                    </button>

                    {#if submitStatus === 'success'}
                        <p class="text-green-600 text-center">Správa bola úspešne odoslaná!</p>
                    {/if}

                    {#if submitStatus === 'error'}
                        <p class="text-red-600 text-center">Nastala chyba. Skúste to prosím znova.</p>
                    {/if}

                    <p class="text-sm text-[#6B5D4F] text-center">
                        Vaše údaje sú prísne dôverné
                    </p>
                </form>
            </div>
        </div>
    </div>
</section>
